import { AuthScene } from '../scenes/auth';

export let Signup = () => {
  return <AuthScene type="signup" />;
};
